module.exports = __webpack_public_path__ + "static/tradee_img1-abcc067573704f5992a0a236436f06c8.png";